// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ky-0";